import { type ReactNode } from 'react';

import { Stack, Text } from '@backyard-ui/core';

interface WrapperProps {
  shopName: string;
  children: ReactNode;
}

export default function Wrapper(props: Readonly<WrapperProps>) {
  const { shopName, children } = props;

  return (
    <>
      <Stack direction="column" spacing="2">
        <Text size="lg" weight="bold">
          {shopName}
        </Text>

        {children}
      </Stack>

      <hr className="mt-4 text-gray-500" />
    </>
  );
}
